import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getLearnings<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { page, per_page, alldata, my_scope, sort_by } = action.payload
        const queryObject: any = {}
        if (page) queryObject['page'] = page
        if (per_page) queryObject['per_page'] = per_page
        if (alldata) queryObject['alldata'] = alldata
        if (my_scope !== undefined) queryObject['my_scope'] = my_scope
        if (sort_by) queryObject['sort_by'] = sort_by

        const APIURL = APIS.TOPLEARNING.LEARNINGS + `?${new URLSearchParams(queryObject).toString()}`

        const resp = yield call(CallApi.POST, APIURL, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e.message, status_code: 400, success: false })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({ message: e?.message || 'Failed to fetch learnings', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getLearnings', action: action?.type })
    }
}
